import { Message, Session } from "../types";

export default abstract class AbstractCache {
  abstract getMessages(): Promise<Message[] | undefined>;
  abstract setMessages(messages: Message[]): Promise<void>;
  abstract getSession(): Promise<Session | undefined>;
  abstract setSession(session: Session): Promise<void>;
}